<template>
  <div>
    <div class="title-item mt-5">Campaign name</div>
    <el-input
      maxlength="50"
      show-word-limit
      placeholder="My campaign..."
      v-model="request.campaignName"
    ></el-input>
  </div>
</template>

<script>
export default {
  props: {
    request: {
      type: Object,
      default: null,
    },
  },
};
</script>